import { render, staticRenderFns } from "./MangaRank.vue?vue&type=template&id=63341767&"
import script from "./MangaRank.vue?vue&type=script&lang=js&"
export * from "./MangaRank.vue?vue&type=script&lang=js&"
import style0 from "./MangaRank.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports